import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {text} from '../text';
import {hooks} from '../hooks';
import {svg} from '../assets/svg';
import {components} from '../components';

import { UserRoundCheck } from 'lucide-react';


export const SignUpAccountCreated: React.FC = () => {
  const {pathname} = useLocation();

  const navigate = hooks.useAppNavigate();

  useEffect(() => {
    setTimeout(() => {
      window.scroll({top: -1, left: 0, behavior: 'smooth'});
    }, 10);
  }, [pathname]);

  const renderBackground = (): JSX.Element => {
    return <components.Background />;
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header logo={true} />;
  };

  const renderContent = (): JSX.Element => {
    return (
      <main
        className="container"
        style={{ justifyContent: 'center', textAlign: 'center' }} // 🔄 Centralizando o conteúdo
      >
        {/* 🔄 Ícone atualizado do Lucide */}
        <UserRoundCheck
          size={60} // Ajustando o tamanho do ícone
          color="#6C6D84" // Mantendo um tom neutro
          style={{ marginBottom: 30, marginLeft: 20 }}
        />

        <text.H2 style={{ marginBottom: 10 }}>Conta criada!</text.H2>
        <text.T16 style={{ marginBottom: 30 }}>
          Sua conta foi criada{'\n'}com sucesso.
        </text.T16>

        <components.Button
          title="Feito"
          onClick={() => navigate('/SignIn')}
        />
      </main>
    );
  };

  return (
    <div id='screen'>
      {renderBackground()}
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
